package ui.app.assign.detail.wheel.editor

import androidx.compose.animation.Crossfade
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import api.AppType
import compose.assets.Svg
import compose.assets.svg.Arrow_left
import tk.mallumo.compose.navigation.ComposableNavNode
import tk.mallumo.utils.DataState
import tools.rememberString
import ui.app.assign.detail.AppDetailArgs
import ui.app.assign.typeName
import ui.widget.*

@ComposableNavNode(AppDetailArgs::class)
@Composable
fun AppEditorWheelUI() {
    with(AppEditorWheelScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AppEditorWheelScope.Content(nnvl: AppEditorWheelScope.Wrapper) {

    Column(Modifier.fillMaxSize()) {
        if (display.isMobileOrSmall) {
            TopAppBar(
                modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                navigationIcon = {
                    IconButton({ nav.up() }) {
                        Icon(Svg.Arrow_left, null)
                    }
                },
                title = {
                    Tabs()
                },
            )
        } else {
            Toolbar(
                nav = nav,
                titlePrefix = AppType.WHEEL.typeName().rememberString(),
                titleSuffix = nnvl.data.id.toString(),
            )
            Tabs()
        }

        Crossfade(vm.activePageIndex, modifier = Modifier.fillMaxSize()) {
            AppEditorWheelScope.Page.all[it].body(this@Content, nnvl)
        }
    }
}

@Composable
fun AppEditorWheelScope.Tabs() {

    InlineTabRow(
        selectedTabIndex = vm.activePageIndex,
        tabsCount = AppEditorWheelScope.Page.all.size,
        itemMaxWidth = 192.dp
    ) { index ->
        InlineTab(
            index = index,
            selectedTabIndex = vm.activePageIndex,
            label = AppEditorWheelScope.Page.all[index].title
        ) {
            vm.activePageIndex = index
        }
    }
}